import { createSlice } from '@reduxjs/toolkit';
import { getCpuArchitectures } from 'ducks/cpu-architectures-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type CpuArchitecturesListState = ReturnType<
  typeof normalizeLookups<'cpu_architecture_name', 'cpu_architecture_id'>
>;

const initialState: CpuArchitecturesListState = [];

const cpuArchitecturesListSlice = createSlice({
  name: Slices.CPU_ARCHITECTURES_LIST,
  initialState,
  reducers: {
    clearCpuArchitecturesList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCpuArchitectures.pending, () => {
        return initialState;
      })
      .addCase(getCpuArchitectures.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'cpu_architecture_name', 'cpu_architecture_id');
      })
      .addCase(getCpuArchitectures.rejected, () => {
        return initialState;
      });
  },
});

export const { clearCpuArchitecturesList } = cpuArchitecturesListSlice.actions;

export default cpuArchitecturesListSlice.reducer;
